import {getScrollableAncestor} from '@albert-io/atomic/helpers/AnchoredFixedPosition/AnchoredFixedPosition.react';

/** Positions that make an element the containing block of its absolute children. */
const CONTAINING_BLOCK_POSITIONS = new Set(['relative', 'absolute', 'fixed', 'sticky']);

/**
 * The pane a margin indicator portals into and positions against: the element's
 * scrolling ancestor, but only while it is a containing block. Without that, an
 * absolute indicator would line up with neither the content nor its scrolling.
 */
export function resolveIndicatorScroller(element: HTMLElement | null): HTMLElement | null {
  const scroller = element && getScrollableAncestor(element);
  if (!scroller || !CONTAINING_BLOCK_POSITIONS.has(getComputedStyle(scroller).position)) {
    return null;
  }
  return scroller;
}

/** Viewport y to scrolled-content y: past the border, then past what's scrolled off. */
export function scrollerContentOffset(scroller: HTMLElement): number {
  return scroller.scrollTop - scroller.getBoundingClientRect().top - scroller.clientTop;
}

/** `element` and its ancestors, up to and including `ancestor`. */
export function selfAndAncestorsThrough(element: Element, ancestor: Element): Element[] {
  const chain: Element[] = [];
  for (let current: Element | null = element; current; current = current.parentElement) {
    chain.push(current);
    if (current === ancestor) {
      break;
    }
  }
  return chain;
}
